import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import {
  getAbandonedOrCancelConsult,
  reSubmitAbandonedOrCancelConsult,
  updateFlagAbandonedOrCancelConsult,
  type AbandonedOrCancelResponse,
} from '../services/reSubmitOrCancelConsultServices';
import { type ActivateConsultResponse } from '../services/caseManagerServices';

export const UseGetAbandonedOrCancelConsult = (consultId: number) => {
  const { data, isLoading, isError, error, refetch } =
    useQuery<AbandonedOrCancelResponse>({
      queryKey: ['AbandonedOrCancelResponse', consultId],
      queryFn: async () => {
        const data = await getAbandonedOrCancelConsult(consultId);
        return data;
      },
      staleTime: 0,
      gcTime: 0,
    });

  return {
    AbandonedOrCancelResponse: data,
    isLoading,
    isError,
    error,
    refetch,
  };
};

export const useReSubmitConsult = (onSuccess: () => void) => {
  const queryClient = useQueryClient();
  return useMutation<
    ActivateConsultResponse,
    Error,
    { userId: string; consultId: number }
  >({
    mutationFn: async ({ userId, consultId }) => {
      const data = await reSubmitAbandonedOrCancelConsult(userId, consultId);
      return data;
    },

    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['ConsultsListResponse'],
      });
      onSuccess();
    },
    onError: (error) => {
      console.error('Error saving consult cancel reason:', error);
    },
  });
};

export const useUpdateAbandonedOrCancelConsult = (onSuccess: () => void) => {
  const queryClient = useQueryClient();
  return useMutation<
    ActivateConsultResponse,
    Error,
    { userId: string; consultId: number; action: string }
  >({
    mutationFn: async ({ userId, consultId, action }) => {
      const data = await updateFlagAbandonedOrCancelConsult(
        userId,
        consultId,
        action
      );
      return data;
    },

    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['ConsultsListResponse'],
      });
      onSuccess();
    },
    onError: (error) => {
      console.error('Error saving consult cancel reason:', error);
    },
  });
};
